module.exports = __webpack_public_path__ + "static/media/visa-secure.bada3931.svg";